<template>
	<div class="login">
		<div class="logo fl">
			<img src="../assets/img/title.png" width="100%" />
		</div>
		<div class="loginForm fl">
			<div class="form">
				<h2 style="color: rgb(26, 188, 156);">灯设计后台管理系统</h2>
				<el-input class="el" v-model="loginName" placeholder="用户名" autofocus></el-input>
				<el-input class="el" v-model="password" type="password" placeholder="密码"></el-input>
				<el-button class="btn" type="success" @click="login" :loading="loading">确定</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				loginName: '',
				password: ''
			}
		},
		methods: {
			login: function() {
				this.loading = true
				this.$http.post("/lightApi/admin/login", {
					usr: this.loginName.trim(),
					pwd: this.password.trim()
				}, {
					emulateJson: true
				}).then(
					(loginData) => {
						if(loginData.body.msg == "ok") {
							sessionStorage.setItem("sessionId", loginData.body.data)
							sessionStorage.setItem("usrName", this.loginName.trim())
							this.$router.push({
								path: '/main',
								query: ''
							})
						} else {
							this.loading = false
							this.$message({
								type: 'error',
								message: loginData.body.msg
							});
						}
					},
					(error) => {
						this.loading = false
						this.$message({
							type: 'error',
							message: '数据连接失败'
						});
					}
				)
			},
			//点击enter键时确定登录
			enterBind: function(){
				var vue = this
				document.onkeydown = function (event) {
	                var e = event || window.event || arguments.callee.caller.arguments[0];
	                if (e && e.keyCode == 13) {
	                	if(location.hash=="#/"){
	                		if(!vue.loading){
	                			vue.login();
	                		}	                		
	                	}
	                }
	            };
			}
		},
		mounted(){
			this.loading = false
			this.enterBind()
		}
	}
</script>

<style scoped>
	.cf {
		overflow: hidden;
	}
	
	.fl {
		float: left;
	}
	
	.fr {
		float: right;
	}
	
	.login {
		min-width: 1160px;
		height: 100%;
		background-color: rgb(58, 58, 58);
		text-align: center;
	}
	
	.logo {
		width: 60%;
		height: 100%;
		line-height: 950px;
	}
	
	.logo img {
		vertical-align: middle;
	}
	
	.loginForm {
		width: 320px;
		position: relative;
		top: 30%;
	}
	
	.form {
		margin: 0 auto;
		width: 230px;
		background: #fff;
		border-radius: 10px;
		box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);
		padding: 30px 40px;
	}
	
	.form h2,
	.form .el {
		padding: 10px 0;
	}
	
	.form .btn {
		width: 100%;
		margin: 10px 0 30px 0;
		color: #fff;
		background: rgb(26, 188, 156);
	}
</style>


// WEBPACK FOOTER //
// src/components/login.vue